<template>
	<div>
		<h4 class="text-center">RECONCILE REPORTING SYSTEM</h4>

		<div class="row">

			<div class="col-auto mb-2 text-left">
				<FilterClient
					@changeFilterClient="changeFilterClient"
					filterId="Ib"
					:clients_prop="clients"
				>
				</FilterClient>
			</div>

			<div v-show="tableView != 'client'" class="col-auto mb-2 text-left">
				<FilterContract class="d-inline-block"
					filterId="order"
					@changeFilterContract="changeFilterContract"
				>
				</FilterContract>
			</div>

			<div class="col-auto mb-2 text-left">
				<FilterDateAndType class="d-inline-block"
					@changeFilterDateAndType="changeFilterDateAndType"
				>
				</FilterDateAndType>
			</div>

			<div class="col-auto mb-2">
				<ExportAsButton class="d-inline-block">
				</ExportAsButton>
			</div>

		</div>

		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-header">
						<h4 class="text-center"></h4>
						<div class="row">
							<div class="col-12 col-md-6">
								<dl class="row mb-0">

									<dt class="col-6">USER ACCESS</dt>
									<dd class="col-6">
										<p>: {{this.$store.getters.getHin}}</p>
									</dd>

									<dt class="col-6">CURRENT REVENUE</dt>
									<dd class="col-6">
										<p>: USD {{Number((totalTurnOver.usd * 0.005).toFixed(2))}}</p>
										<p>: IDR {{Number((totalTurnOver.usd * 0.005 * streamingRate.streamBuy).toFixed(2))}}</p>
									</dd>
								</dl>
							</div>

							<div class="col-12 col-md-6">
								<dl class="row mb-0">
									<dt class="col-auto">TOTAL TURN OVER</dt>
									<dd class="col-6">
										<dl class="row mb-0">
											<dt class="col-12"></dt>
											<dd class="col-9"><p>USD {{totalTurnOver.usd}}</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>IDR {{totalTurnOver.anotherCurrency}}</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>TOZ {{totalTurnOver.toz}}</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>GRAM {{totalTurnOver.gram}}</p></dd>
										</dl>
									</dd>
								</dl>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div v-if="tableView == 'all'" class="col-12">
				<table class="table table-striped">
					<thead class="text-center" style="background-color: #0f0f17">
						<tr>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">NO.</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">ACCOUNT NAME</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">HIN</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">BUY</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">SELL</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL TRADE <br> VOLUME <br> (USD) </th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> TOZ</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> GRAM</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">RATE <br> RATIO <br> (%)</th>
						</tr>
						<tr>
							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>

							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="(rrsStatus != 'loading')">
							<tr v-for="(item, index) in rrsData" class="c-row-table cursor-pointer text-right" :key="item.ib._id" @click="showDetailClient()">
								<td class="text-center">{{index + 1}}</td>
								<td class="text-left">{{item.ib.personal_data[0].full_name}}</td>
								<td>{{item.ib.hin_abx}}</td>
								<td>{{item.gold.buy.total_price}}</td>
								<td>{{item.gold.buy.totalToz}}</td>
								<td>{{item.gold.buy.total_gram}}</td>
								<td>{{item.gold.sell.total_price}}</td>
								<td>{{item.gold.sell.totalToz}}</td>
								<td>{{item.gold.sell.total_gram}}</td>
								<td>{{item.gold.total_trade}}</td>
								<td>{{item.gold.totalToz}}</td>
								<td>{{item.gold.total_gram}}</td>
								<td class="text-center">{{item.gold.rateRatio}}</td>
							</tr>
							<tr v-if="rrsData.length < 1">
								<td colspan="13" class="text-center">No data available in table</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="14">
									<Loader
										size_prop="10em"
									></Loader>
								</td>
							</tr>
						</template>
					</tbody>
					<tfoot>

					</tfoot>
				</table>
			</div>

			<div v-if="tableView == 'ib'" class="col-12">
				<table class="table table-striped">
					<thead class="text-center" style="background-color: #0f0f17">
						<tr>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">NO.</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">ACCOUNT NAME</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">HIN</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">BUY</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">SELL</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL TRADE <br> VOLUME</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> TOZ</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> GRAM</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">RATE <br> RATIO <br> (%)</th>
						</tr>
						<tr>
							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>

							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="(rrsStatus != 'loading')">
							<tr v-for="(item, index) in rrsDataIb" class="c-row-table cursor-pointer text-right" :key="item.identity._id" @click="showDetailClient()">
								<td class="text-center">{{index + 1}}</td>
								<td class="text-left">{{item.identity.personal_data[0].full_name}}</td>
								<td>{{item.identity.hin_abx}}</td>
								<td>{{item.gold.buy.total_price}}</td>
								<td>{{item.gold.buy.totalToz}}</td>
								<td>{{item.gold.buy.total_gram}}</td>
								<td>{{item.gold.sell.total_price}}</td>
								<td>{{item.gold.sell.totalToz}}</td>
								<td>{{item.gold.sell.total_gram}}</td>
								<td>{{item.gold.total_trade}}</td>
								<td>{{item.gold.totalToz}}</td>
								<td>{{item.gold.total_gram}}</td>
								<td class="text-center">{{item.gold.rateRatio}}</td>
							</tr>
							<tr v-if="rrsDataIb.length < 1">
								<td colspan="13" class="text-center">No data available in table</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="14">
									<Loader
										size_prop="10em"
									></Loader>
								</td>
							</tr>
						</template>
					</tbody>
					<tfoot>

					</tfoot>
				</table>
			</div>

			<div v-if="tableView == 'client'" class="col-12">
				<table class="table table-striped">
					<thead class="text-center" style="background-color: #0f0f17">
						<tr>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">NO.</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">PRODUCT</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">HIN</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">BUY</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">SELL</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL TRADE <br> VOLUME</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> TOZ</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> GRAM</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">RATE <br> RATIO <br> (%)</th>
						</tr>
						<tr>
							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>

							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="(rrsStatus != 'loading')">
							<tr v-for="(item, index) in clientData" class="c-row-table cursor-pointer text-right" :key="item.name" @click="showDetailClient()">
								<td class="text-center">{{index + 1}}</td>
								<td class="text-left">{{item.name}}</td>
								<td>{{selectedClient.hin_abx}}</td>
								<td>{{item.buy.total_price}}</td>
								<td>{{item.buy.totalToz}}</td>
								<td>{{item.buy.total_gram}}</td>
								<td>{{item.sell.total_price}}</td>
								<td>{{item.sell.totalToz}}</td>
								<td>{{item.sell.total_gram}}</td>
								<td>{{item.total_trade}}</td>
								<td>{{item.totalToz}}</td>
								<td>{{item.total_gram}}</td>
								<td class="text-center">{{item.rateRatio}}</td>
							</tr>
							<tr v-if="clientData.length < 1">
								<td colspan="13" class="text-center">No data available in table</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="14">
									<Loader
										size_prop="10em"
									></Loader>
								</td>
							</tr>
						</template>
					</tbody>
					<tfoot>

					</tfoot>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import {Decimal} from 'decimal.js'

	import Loader from '@/components/Loader.vue'
	import FilterClient from '@/components/FilterClient.vue'
	import FilterContract from '@/components/FilterContract.vue'
	import FilterDateAndType from '@/components/FilterDateAndType.vue'
	import ExportAsButton from '@/components/ExportAsButton.vue'

	export default {
		name: 'FullMember',

		components: {
			Loader,
			FilterClient,
			FilterContract,
			FilterDateAndType,
			ExportAsButton
		},

		data() {
			const today = new Date(Date.now())
			let todayDay = today.getDay()
			let tempDay = new Date(Date.now())
			let tempWeek = new Date(Date.now())
			let tempMonth = new Date(Date.now())
			let tempYear = new Date(Date.now())
			return {
				clientsStatus: 'loading',
				clients: [],
				clientsFilterIb: '',

				grToTozMultiplier: 0.0321507,

				rrsClientStatus: 'loading',
				products: [],

				rrsStatus: 'loading',
				rrsData: [],
				rrsDataIb: [],
				
				totalTurnOver: {
					usd: 0,
					anotherCurrency: 0,
					toz: 0,
					gram: 0
				},

				reportType: 'day',
				reportMonth: 'january',
				reportYear: '2019',

				startDateDay: new Date(tempDay.setDate(tempDay.getDate() - 1)),
				endDate: `${tempDay.getFullYear()}-${tempDay.getMonth() + 1 < 10 ? '0' : ''}${tempDay.getMonth() + 1}-${tempDay.getDate() + 1 < 10 ? '0' : ''}${tempDay.getDate() + 1}`,

				startDateWeek: new Date(tempWeek.setDate(tempWeek.getDate() - todayDay + 1)),
				weeklyDateList: [],

				startDateMonth: new Date(tempMonth.setDate(1)),
				monthlyDateList: [],

				startDateYear: new Date(new Date(tempYear.setDate(1)).setMonth(0)),
				yearlyDateList: [],

				tableView: 'all',

				selectedClient: 'all',
				
				selectedContracts: ["0.01 gr", "1 gr", "100 gr", "1 kg", "10 kg"],

				selectedDateAndType: {
					type: 'all',
					startDate: '', 
					endDate: ''
				},

				clientData: {},
			}
		},

		computed: {
			// watcherChangeFilter() {
			// 	return `${this.startDateDay}${this.startDateWeek}${this.startDateMonth}${this.startDateYear}${this.endDate}`
			// },

			streamingRate() {
				return this.$store.getters.getStreamingRate
			},

			startDateDayInInput: {
				get: function() {
					let temp = this.startDateDay
					return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}`
				},
				set: function(newValue) {
					this.startDateDay = new Date(newValue)
				}
			},

			startDateWeekInInput: {
				get: function() {
					let temp = this.startDateWeek
					if (temp) {
						return `${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}/${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
					this.startDateWeek = temp
				}
			},

			startDateMonthInInput: {
				get: function() {
					let temp = this.startDateMonth
					if (temp) {
						return `01/${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
					this.startDateMonth = temp
				}
			},

			startDateYearInInput: {
				get: function() {
					let temp = this.startDateYear
					if (temp) {
						return `01/01/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					if (newValue) {
						let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
						this.startDateYear = temp
					}
				}
			},
		},

		watch: {
			// watcherChangeFilter() {
			// 	this.changeFilter()
			// },
			reportType(newValue) {
				if (newValue == 'week') {
					if (this.weeklyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let todayDay = todayDate.getDay()
						let nearestMondayDate = new Date(todayDate.setDate(todayDate.getDate() - todayDay + 1))

						for (let i = 0; i < 500; i++) {
							this.weeklyDateList.push(`${nearestMondayDate.getDate() < 10 ? '0' : ''}${nearestMondayDate.getDate()}/${nearestMondayDate.getMonth() + 1 < 10 ? '0' : ''}${nearestMondayDate.getMonth() + 1}/${nearestMondayDate.getFullYear()}`)
							nearestMondayDate = new Date(nearestMondayDate.setDate(nearestMondayDate.getDate() - 7))
						}

					}
				}else if (newValue == 'month') {
					if (this.monthlyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let todayMonth = todayDate.getMonth() // 0 = January
						let monthDate = new Date(todayDate.getFullYear() + '-' + (todayMonth + 1 < 10 ? '0' : '') + String(todayMonth + 1) + '-01')

						for (let i = 0; i < 241; i++) {
							this.monthlyDateList.push(`01/${monthDate.getMonth() + 1 < 10 ? '0' : ''}${monthDate.getMonth() + 1}/${monthDate.getFullYear()}`)
							monthDate =  new Date(monthDate.setMonth(monthDate.getMonth() - 1))
						}

					}
				}else {
					if (this.yearlyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let yearDate = new Date(todayDate.getFullYear() + '-01-01')

						for (let i = 0; i < 241; i++) {
							this.yearlyDateList.push(`01/01/${yearDate.getFullYear()}`)
							yearDate =  new Date(yearDate.setFullYear(yearDate.getFullYear() - 1))
						}
					
					}
				}
				
				this.changeFilter()
			}
		},

		created() {
			axios({
				method: 'get',
				url: process.env.VUE_APP_BACKEND_URL+'/rrs/fm/list/branch'
			}).then(response => {
				this.clients = response.data.data
				console.log('Berhasil get list clients for FM', response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request);
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message);
				}
				console.log("Gagal get list clients for FM", error.config)
			})

			this.setRrs()
		},

		methods: {
			setRrs() {
				let selectedContracts = this.selectedContracts
				let contractValue = [ '', '', '', '', '', '', '']
				let contractsParam = ''
				
				if (selectedContracts.length > 0) {
					selectedContracts.forEach((item) => {
						if (item == '0.01 gr') {
							contractValue[5] = '5'
						}else if (item == '1 gr') {
							contractValue[6] = '6'
						}else if (item == '100 gr') {
							contractValue[1] = '1'
						}else if (item == '1 kg') {
							contractValue[3] = '3'
						}else if (item == '10 kg') {
							contractValue[4] = '4'
						}else if (item == '10 Oz') {
							contractValue[2] = '2'
						}
					})
				}

				contractsParam = `contract[]=${contractValue[1]}&contract[]=${contractValue[3]}&contract[]=${contractValue[4]}&contract[]=${contractValue[5]}&contract[]=${contractValue[6]}&`

				let reportType = this.selectedDateAndType.type
				let startDate = this.selectedDateAndType.startDate
				let endDate = this.selectedDateAndType.endDate

				if (reportType == 'all') {
					reportType = ''
				}

				if (startDate) {
					startDate = `${startDate.getFullYear()}-${startDate.getMonth() + 1 < 10 ? '0' : ''}${startDate.getMonth() + 1}-${startDate.getDate() < 10 ? '0' : ''}${startDate.getDate()}`
				}

				if (endDate) {
					endDate = `${endDate.getFullYear()}-${endDate.getMonth() + 1 < 10 ? '0' : ''}${endDate.getMonth() + 1}-${endDate.getDate() < 10 ? '0' : ''}${endDate.getDate()}`
				}

				if (this.tableView == 'all') {
					this.rrsStatus = 'loading'
					axios({
						method: 'get',
						url: process.env.VUE_APP_BACKEND_URL+'/rrs/fm?' + contractsParam + 'type=' + reportType + '&startDate=' + startDate + '&endDate=' + endDate
					}).then(response => {
						console.log('Berhasil rss FM ASDASD', response)
						this.rrsData = []
						this.totalTurnOver= {
							usd: 0,
							anotherCurrency: 0,
							toz: 0,
							gram: 0
						}

						if (response.data.data[0].ib.hin_abx) {
							this.rrsData = response.data.data

							let tempUsd = 0
							let tempGram = 0
							this.rrsData.forEach((element, index) => {
								this.rrsData[index].gold.buy.total_price = Number((this.rrsData[index].gold.buy.total_price).toFixed(2))
								this.rrsData[index].gold.buy.totalToz = Number(Decimal.mul(element.gold.buy.total_gram, this.grToTozMultiplier))
								this.rrsData[index].gold.buy.total_gram = Number((this.rrsData[index].gold.buy.total_gram).toFixed(2))

								this.rrsData[index].gold.sell.total_price = Number((this.rrsData[index].gold.sell.total_price).toFixed(2))
								this.rrsData[index].gold.sell.totalToz = Number(Decimal.mul(element.gold.sell.total_gram, this.grToTozMultiplier))
								this.rrsData[index].gold.sell.total_gram = Number((this.rrsData[index].gold.sell.total_gram).toFixed(2))
								
								this.rrsData[index].gold.total_trade = Number((this.rrsData[index].gold.total_trade).toFixed(2))
								this.rrsData[index].gold.totalToz = Number((element.gold.total_gram * this.grToTozMultiplier).toFixed(2))
								this.rrsData[index].gold.total_gram = Number((this.rrsData[index].gold.total_gram).toFixed(2))
								
								this.rrsData[index].rateRatio = Number(((element.gold.sell.total_price / (element.gold.sell.total_price + element.gold.buy.total_price)) * 100).toFixed(2))

								tempUsd += element.gold.total_trade
								tempGram += element.gold.total_gram
							})

							this.totalTurnOver = {
								usd: Number((tempUsd).toFixed(2)),
								anotherCurrency: Number((tempUsd * this.streamingRate.streamBuy).toFixed(2)),
								toz: Number(Decimal.mul(tempGram, this.grToTozMultiplier)),
								gram: Number(tempGram.toFixed(2)),
							}
						}

						this.rrsStatus = 'success'
					}).catch(error => {
						if (error.response) {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */

							if (error.response.data.message == "There are no clients under FM!") {
								this.rrsDataIb = []
								this.totalTurnOver = {
									usd: 0,
									anotherCurrency: 0,
									toz: 0,
									gram: 0
								}
							}

							console.log(error.response.data);
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							/*
							 * The request was made but no response was received, `error.request`
							 * is an instance of XMLHttpRequest in the browser and an instance
							 * of http.ClientRequest in Node.js
							 */
							console.log(error.request);
						} else {
							// Something happened in setting up the request and triggered an Error
							console.log(error.message);
						}
						this.rrsStatus = 'error'
						console.log("Gagal rss FM", error.config)
					})
				}else {
					this.rrsStatus = 'loading'
					axios({
						method: 'get',
						url: process.env.VUE_APP_BACKEND_URL+'/rrs/fm/get/branch?hin=' + this.selectedClient.hin_abx + '&' + contractsParam + 'type=' + reportType + '&startDate=' + startDate + '&endDate=' + endDate
					}).then(response => {
						let temp = response.data.data
						if (this.tableView == 'client') {
							this.totalTurnOver = {
								usd: 0,
								anotherCurrency: 0,
								toz: 0,
								gram: 0
							}

							temp.contract_micro.name = 'DG001 0.01 GR POOL'
							temp.contract_1gr.name = 'DG1 1 GR POOL'
							temp.contract_100gr.name = 'DG100 100 GR NON POOL'
							temp.contractId_10oz.name = 'DG1K 1 KG NON POOL'
							temp.contract_10kg.name = 'DG10K 10 KG NON POOL'

							temp.contract_micro.weight = 0.01
							temp.contract_1gr.weight = 1
							temp.contract_100gr.weight = 100
							temp.contractId_10oz.weight = 1000
							temp.contract_10kg.weight = 10000

							this.clientData = [temp.contract_micro, temp.contract_1gr, temp.contract_100gr, temp.contractId_10oz, temp.contract_10kg]

							let tempUsd = 0
							let tempGram = 0
							this.clientData.forEach((element, index) => {

								this.clientData[index].buy.total_price = Number((this.clientData[index].buy.total_price).toFixed(2))
								this.clientData[index].buy.totalToz = Number(Decimal.mul(element.gold.buy.total_gram, this.grToTozMultiplier))
								this.clientData[index].buy.total_gram = Number((this.clientData[index].buy.total_gram).toFixed(2))

								this.clientData[index].sell.total_price = Number((this.clientData[index].sell.total_price).toFixed(2))
								this.clientData[index].sell.totalToz = Number(Decimal.mul(element.gold.sell.total_gram, this.grToTozMultiplier))
								this.clientData[index].sell.total_gram = Number((this.clientData[index].sell.total_gram).toFixed(2))
								
								this.clientData[index].total_trade = Number((this.clientData[index].total_trade).toFixed(2))
								this.clientData[index].totalToz = Number((element.total_gram * this.grToTozMultiplier).toFixed(2))
								this.clientData[index].total_gram = Number((this.clientData[index].total_gram).toFixed(2))

								this.clientData[index].rateRatio = Number(((element.sell.total_price / (element.sell.total_price + element.buy.total_price)) * 100).toFixed(2))

								tempUsd += element.total_trade
								tempGram += element.total_gram
							})

							this.totalTurnOver = {
								usd: Number((tempUsd).toFixed(2)),
								anotherCurrency: Number((tempUsd * this.streamingRate.streamBuy).toFixed(2)),
								toz: Number(Decimal.mul(tempGram, this.grToTozMultiplier)),
								gram: Number((tempGram).toFixed(2)),
							}
						}else {
							this.rrsDataIb = []
							this.totalTurnOver = {
								usd: 0,
								anotherCurrency: 0,
								toz: 0,
								gram: 0
							}

							if (response.data.data[0].identity.hin_abx) {
								this.rrsDataIb = response.data.data

								let tempUsd = 0
								let tempGram = 0
								this.rrsDataIb.forEach((element, index) => {
									this.rrsDataIb[index].gold.buy.total_price = Number((this.rrsDataIb[index].gold.buy.total_price).toFixed(2))
									this.rrsDataIb[index].gold.buy.totalToz = Number(Decimal.mul(element.gold.buy.total_gram, this.grToTozMultiplier))
									this.rrsDataIb[index].gold.buy.total_gram = Number((this.rrsDataIb[index].gold.buy.total_gram).toFixed(2))

									this.rrsDataIb[index].gold.sell.total_price = Number((this.rrsDataIb[index].gold.sell.total_price).toFixed(2))
									this.rrsDataIb[index].gold.sell.totalToz = Number(Decimal.mul(element.gold.sell.total_gram, this.grToTozMultiplier))
									this.rrsDataIb[index].gold.sell.total_gram = Number((this.rrsDataIb[index].gold.sell.total_gram).toFixed(2))
									
									this.rrsDataIb[index].gold.total_trade = Number((this.rrsDataIb[index].gold.total_trade).toFixed(2))
									this.rrsDataIb[index].gold.totalToz = Number((element.gold.total_gram * this.grToTozMultiplier).toFixed(2))
									this.rrsDataIb[index].gold.total_gram = Number((this.rrsDataIb[index].gold.total_gram).toFixed(2))
									
									this.rrsDataIb[index].rateRatio = Number(((element.gold.sell.total_price / (element.gold.sell.total_price + element.gold.buy.total_price)) * 100).toFixed(2))

									tempUsd += element.gold.total_trade
									tempGram += element.gold.total_gram
								})

								this.totalTurnOver = {
									usd: Number((tempUsd).toFixed(2)),
									anotherCurrency: Number((tempUsd * this.streamingRate.streamBuy).toFixed(2)),
									toz: Number(Decimal.mul(tempGram, this.grToTozMultiplier)),
									gram: Number(tempGram.toFixed(2)),
								}
							}
						}

						this.rrsStatus = 'success'
						console.log('Berhasil GET Specific IB Client Reconciliation under FM', response, this.clientData)
					}).catch(error => {
						if (error.response) {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */

							if (error.response.data.message == "There are no clients under IB!") {
								this.rrsDataIb = []
								this.totalTurnOver = {
									usd: 0,
									anotherCurrency: 0,
									toz: 0,
									gram: 0
								}
							}

							console.log(error.response.data);
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							/*
							 * The request was made but no response was received, `error.request`
							 * is an instance of XMLHttpRequest in the browser and an instance
							 * of http.ClientRequest in Node.js
							 */
							console.log(error.request);
						} else {
							// Something happened in setting up the request and triggered an Error
							console.log(error.message);
						}
						this.rrsStatus = 'error'
						console.log("Gagal GET Specific IB Client Reconciliation under FM", error.config)
					})

				}
			},

			changeFilter() {
				let startDate = this.startDateDay
				let endDate = this.endDate

				if (this.reportType == 'day') {
					startDate = this.startDateDay
				}else if (this.reportType == 'week') {
					startDate = this.startDateWeek
				}else if (this.reportType == 'month') {
					startDate = this.startDateMonth
				}else {
					startDate = this.startDateYear
				}

				if (startDate) {
					startDate = `${startDate.getFullYear()}-${startDate.getMonth() + 1 < 10 ? '0' : ''}${startDate.getMonth() + 1}-${startDate.getDate() < 10 ? '0' : ''}${startDate.getDate()}`
				}

				this.rrsClientStatus = 'loading'
				this.products = []
				axios({
					method: 'get',
					url:process.env.VUE_APP_BACKEND_URL+'/rss/client?type='+ this.reportType +'&startDate='+ startDate +'&endDate='+ endDate
				}).then(response => {
					let temp = response.data.data
					temp.contract_micro.name = 'DG001 0.01 GR POOL'
					temp.contract_1gr.name = 'DG1 1 GR POOL'
					temp.contract_100gr.name = 'DG100 100 GR NON POOL'
					temp.contractId_10oz.name = 'DG1K 1 KG NON POOL'
					temp.contract_10kg.name = 'DG10K 10 KG NON POOL'

					temp.contract_micro.weight = 0.01
					temp.contract_1gr.weight = 1
					temp.contract_100gr.weight = 100
					temp.contractId_10oz.weight = 1000
					temp.contract_10kg.weight = 10000

					this.products = [temp.contract_micro, temp.contract_1gr, temp.contract_100gr, temp.contractId_10oz, temp.contract_10kg]

					let tempUsd = 0
					let tempGram = 0
					this.products.forEach((product, index) => {
						let pembagi = product.buy.total_price
						this.products[index].buy.total_gram = Number((product.buy.total_gram * product.weight).toFixed(2))
						this.products[index].sell.total_gram = Number((product.sell.total_gram * product.weight).toFixed(2))
						this.products[index].total_gram = Number((product.total_gram * product.weight).toFixed(2))

						if (pembagi == 0) {
							pembagi = 1
						}
						this.products[index].rateRatio = (product.sell.total_price / pembagi) * 100

						tempUsd += product.total_trade
						tempGram += product.total_gram
					})

					this.totalTurnOver = {
						usd: tempUsd,
						anotherCurrency: tempUsd * this.streamingRate.streamBuy,
						toz: tempGram * this.grToTozMultiplier,
						gram: tempGram,
					}

					this.rrsClientStatus = 'success'
					console.log('berhasil rrs client', response, this.products)
				}).catch(error => {
					if (error.response) {
						/*
						 * The request was made and the server responded with a
						 * status code that falls out of the range of 2xx
						 */
						console.log(error.response.data);
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						/*
						 * The request was made but no response was received, `error.request`
						 * is an instance of XMLHttpRequest in the browser and an instance
						 * of http.ClientRequest in Node.js
						 */
						console.log(error.request);
					} else {
						// Something happened in setting up the request and triggered an Error
						console.log(error.message);
					}

					this.rrsClientStatus = 'error'
					console.log('gagal rrs client', error.config);
				})		
			},

			changeFilterClient(clientData) {
				let temp = clientData
				if (temp != 'all') {
					const template = { IB: 'ib', PB: 'fm', LP: 'lp', PC: 'client' }
					this.tableView = template[temp.hin_abx.substr(0, 2)]
				}else {
					this.tableView = 'all'
				}

				this.selectedClient = clientData
				this.setRrs()
			},

			changeFilterContract(selectedContracts) {
				this.selectedContracts = selectedContracts
				this.setRrs()
			},

			changeFilterDateAndType(data) {
				this.selectedDateAndType = data
				this.setRrs()
			},

			clearStartDate(value) {
				if (value == 'week') {
					this.startDateWeek = ''
				}else if (value == 'month') {
					this.startDateMonth = ''
				}else if (value == 'year') {
					this.startDateYear = ''
				}
			}
		}
	}
</script>